/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeflyerfollowhint3Inputs */

const en_placeflyerfollowhint3 = /** @type {(inputs: Placeflyerfollowhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For the window, the till and tables: guests follow your place and hear about events and offers.`)
};

const de_placeflyerfollowhint3 = /** @type {(inputs: Placeflyerfollowhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für Fenster, Kassa und Tische: Gäste folgen deinem Ort und erfahren von Events und Aktionen.`)
};

/**
* | output |
* | --- |
* | "For the window, the till and tables: guests follow your place and hear about events and offers." |
*
* @param {Placeflyerfollowhint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placeflyerfollowhint3 = /** @type {((inputs?: Placeflyerfollowhint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeflyerfollowhint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placeflyerfollowhint3(inputs)
	return de_placeflyerfollowhint3(inputs)
});
export { placeflyerfollowhint3 as "placeFlyerFollowHint" }